import React, { FC, ReactNode, ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { FeatureFlag, useFeatureFlag } from '@/services/featureFlags/featureFlags.service';

interface FeatureFlagProtectedRouteProps {
  children: ReactNode;
  flag: FeatureFlag;
  redirectPath?: string;
}

const FeatureFlagProtectedRoute: FC<FeatureFlagProtectedRouteProps> = ({ children, flag, redirectPath = '/' }) => {
  const isEnabled = useFeatureFlag(flag);

  // If the feature is disabled, redirect to the specified path
  if (!isEnabled) {
    return <Navigate to={redirectPath} replace />;
  }

  // If the feature is enabled, render the children
  return children as ReactElement;
};

export default FeatureFlagProtectedRoute;
